module.exports = __webpack_public_path__ + "static/media/Ted.8e421aca.jpg";